module.exports = __webpack_public_path__ + "img/app-anwang.6124cda0.webp";